import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-audio-not-uploaded',
  templateUrl: './audio-not-uploaded.component.html',
  styleUrls: ['./audio-not-uploaded.component.scss']
})
export class AudioNotUploadedComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal) { }

  @Input() public type;
  @Input() public message;
  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }

}
